import React, { useMemo } from 'react';
import { UserService } from '../../../../../support/services/api'
import { useQuery } from 'react-query';
import Choices from './Choices';
import Identification from './Identification';
import Contribution from './Contribution';
import Resume from './Resume/index';
import Header from './Header';
import Button from './Button';


export default function Summary(props) {
  const { commands, sharedStates, metaStates } = props;
  const {
    order: {
      deliveryValue, productsCounter, productsValue, donationValue, distanceText
    },
    space,
    process,
    consumerSpaceData,
    userId,
    offers,
    basketItems,
    MAXSTEPS,
    order
  } = sharedStates;
  
  const items = useMemo(() => basketItems.reduce((acc, cv) => {
    const offer = offers?.filter((item) => cv.id === item.id)[0];
    if (!offer) return acc;
    return ([...acc, {
      ...offer,
      basketAmount: cv.amount,
    }]);
  }, []), [basketItems, offers]);

  const {
    data: user, isLoading, isIdle, isFetching,
  } = useQuery(
    ['user', userId],
    () => UserService().getByIds([userId]),
    {
      keepPreviousData: true,
      enabled: !!userId,
      select: (data) => (data.length ? data[0] : undefined),
    },
  );

  return (
    <section className="step-container">
      <Header
        commands={commands}
        sharedStates={{ process, space }}
      />
      <div className="order-statement-container">
        <Identification remoteStates={{user, space}}  sharedStates={{donation:order.donationValue}}/>
        <Contribution commands={commands.order} sharedStates={{donation: order.donationValue}}/>
        <Choices sharedStates={{order, consumerSpaceData}} commands={commands.process}/>
        <Resume sharedStates={{ items, productsCounter, productsValue, deliveryValue, donationValue, distanceText }}/>
        <Button sharedStates={{donation:order.donationValue, order, userId, consumerSpaceData, basketItems}} commands={commands} metaStates={metaStates}/>
      </div>
    </section>
  );
}
